import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

const AttendeeCard = ({ attendee, handleSelect, xs = 4 }) => {
  if (attendee?.matchScore === undefined) return null;

  const liked = Boolean(attendee?.like);

  return (
    <Grid item xs={xs}>
      <Box
        onClick={() => handleSelect(attendee)}
        sx={{
          position: "relative",
          width: "100%",
          aspectRatio: "4 / 5",
          borderRadius: 3,
          overflow: "hidden",
          cursor: "pointer",
          backgroundColor: "grey.300",
          boxShadow: 3,
        }}
      >
        {attendee?.profileImage ? (
          <Box
            component="img"
            src={attendee.profileImage}
            alt={`${attendee?.firstName} ${attendee?.lastName}`}
            sx={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        ) : (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <AccountCircleIcon sx={{ width: 64, height: 64, color: "grey.500" }} />
          </Box>
        )}

        <Box
          sx={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            height: "50%",
            background:
              "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%)",
            pointerEvents: "none",
          }}
        />

        <Box
          aria-label={`Match score is ${attendee?.matchScore}%`}
          sx={{
            position: "absolute",
            top: 6,
            right: 6,
            display: "flex",
            alignItems: "center",
            gap: 0.4,
            px: 0.7,
            py: 0.25,
            borderRadius: 5,
            backgroundColor: liked ? "#68C371" : "rgba(255,255,255,0.92)",
            boxShadow: 1,
            transition: "background-color 0.2s ease",
          }}
        >
          {liked ? (
            <FavoriteIcon sx={{ fontSize: 14, color: "#fff" }} />
          ) : (
            <FavoriteBorderIcon sx={{ fontSize: 14, color: "primary.main" }} />
          )}
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 700,
              lineHeight: 1,
              color: liked ? "#fff" : "text.primary",
            }}
          >
            {attendee?.matchScore}%
          </Typography>
        </Box>

        <Typography
          noWrap
          sx={{
            position: "absolute",
            left: 8,
            right: 8,
            bottom: 8,
            color: "#fff",
            fontWeight: 700,
            fontSize: 14,
            textShadow: "0 1px 3px rgba(0,0,0,0.65)",
          }}
        >
          {attendee?.firstName}
        </Typography>
      </Box>
    </Grid>
  );
};

export default AttendeeCard;
